module.exports = __webpack_public_path__ + "static/media/rebecca-eric-recession@1x.0418948a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rebecca-eric-recession@1x.jpg
// module id = 451
// module chunks = 0